<template>
  <div class="l-container VersionsIndex">
    <span style="margin-top: 10px; display: inline-block">現在表示数 : {{max}} </span>
    <!-- <div>{{obj.searchUrl}}</div> -->
    <!-- <div>{{exp}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">Version ID</template>
      <template v-if="this.sortColumn === 'item_type'">item_type</template>
      <template v-if="this.sortColumn === 'item_id'">item_id</template>
      <template v-if="this.sortColumn === 'event'">event</template>
      <template v-if="this.sortColumn === 'whodunnit'">作業者</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
       : {{sortState}}
    </span>
    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">Version ID</btn>
        <btn class="m-btn--column" @click.native="switchV('item_type')" v-bind:class="{ 'active': item_type }">item_type</btn>
        <btn class="m-btn--column" @click.native="switchV('item_id')" v-bind:class="{ 'active': item_id }">item_id</btn>
        <btn class="m-btn--column" @click.native="switchV('event')" v-bind:class="{ 'active': event }">event</btn>
        <btn class="m-btn--column" @click.native="switchV('whodunnit')" v-bind:class="{ 'active': whodunnit }">作業者</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <btn class="m-btn resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="item_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.item_type" :options="item_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="item_id"><td-c class="sticky-1"><input v-model="search.item_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="event">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.event" :options="eventSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="whodunnit">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.whodunnit" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="item_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_item_type" :options="item_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="item_id"><td-c class="sticky-2"><input v-model="search.not_item_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="event">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_event" :options="eventSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="whodunnit">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_whodunnit" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="id"><th-c class="sticky-3" @click.native='sort("id")'>Version ID</th-c></template>
          <template v-if="item_type"><th-c class="sticky-3" @click.native='sort("item_type")'>item_type</th-c></template>
          <template v-if="item_id"><th-c class="sticky-3" @click.native='sort("item_id")'>item_id</th-c></template>
          <template v-if="event"><th-c class="sticky-3" @click.native='sort("event")'>event</th-c></template>
          <template v-if="whodunnit"><th-c class="sticky-3" @click.native='sort("whodunnit")'>作業者</th-c></template>
          <template v-if="created_at"><th-c class="sticky-3" @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c @click.native='linkVersion(list)' slot="tr-td" v-for="(list, index) in mapVersions" :key="index.id" class="tr_hover">
          <template v-if="id"><td-c>{{list.id}}</td-c></template>
          <template v-if="item_type">
            <td-c v-if="list.item_type === 'Contract'">経理 契約情報</td-c>
            <td-c v-if="list.item_type === 'Paymentdetail'">経理 テキスト支払</td-c>
            <td-c v-if="list.item_type === 'Paymentdetails2'">経理 管理費支払</td-c>
            <td-c v-if="list.item_type === 'Appointment'">NEO AP情報</td-c>
            <td-c v-if="list.item_type === 'Agreement'">NEO 契約情報</td-c>
          </template>
          <template v-if="item_id"><td-c>{{list.item_id}}</td-c></template>
          <template v-if="event">
            <td-c v-if="list.event === 'create'">作成</td-c>
            <td-c v-if="list.event === 'update'">更新</td-c>
            <td-c v-if="list.event === 'destroy'">削除</td-c>
          </template>
          <template v-if="whodunnit">
            <td-c>{{list.mapWhodunnit}}</td-c>
          </template>
          <template v-if="created_at">
            <td-c>{{list.mapCreated_at}}</td-c>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/versions/search?limit=' + config.LIMIT

// var TIMER = null // 入力されるのを待つ
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'version',
  pageNames: 'versions'
}

let _ = window._
export default {
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    versions () {
      return this.$store.getters.versions
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    // filter
    filteredUsers: function () {
      let self = this
      if (self.user.office_id === 1) {
        return self.users.filter(user => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.users.filter(user => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.users.filter(user => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.users.filter(user => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.users.filter(user => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.users.filter(user => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.users.filter(user => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.users.filter(user => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.users.filter(user => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.users.filter(user => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.users.filter(user => {
          return user.hide_flag !== 1
        })
      }
    },

    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    // order By
    orderedVersions () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.versions, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.versions, this.sortColumn)
      }
    },

    mapVersions () {
      let self = this
      return self.orderedVersions.map(version => {
        version.mapWhodunnit = self.calcUser(version.whodunnit)
        version.mapCreated_at = self.calcDateTime(version.created_at)
        return version
      })
    }
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
      }
    }
  },
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',
      id: true,
      item_type: true,
      item_id: true,
      event: true,
      whodunnit: true,
      created_at: true,

      search: {
        id: '',
        item_type: '',
        item_id: '',
        event: '',
        whodunnit: '',
        created_at: '',

        not_id: '',
        not_item_type: '',
        not_item_id: '',
        not_event: '',
        not_whodunnit: '',
        not_created_at: ''
      },

      watch: {
        item_type: '',
        event: '',
        whodunnit: '',

        not_item_type: '',
        not_event: '',
        not_whodunnit: ''
      },

      item_typeSelect: [
        { name: '経理 契約情報', value: 'Contract' },
        { name: '経理 テキスト支払', value: 'Paymentdetail' },
        { name: '経理 管理費支払', value: 'Paymentdetails2' },
        { name: 'NEO AP情報', value: 'Appointment' },
        { name: 'NEO 契約情報', value: 'Agreement' }
      ],

      eventSelect: [
        { name: '作成', value: 'create' },
        { name: '更新', value: 'update' },
        { name: '削除', value: 'destroy' }
      ]
    }
  },
  watch: {
    'watch.item_type': function (now, old) {
      if (now) {
        this.search.item_type = now.value
      } else {
        this.search.item_type = ''
      }
    },

    'watch.not_item_type': function (now, old) {
      if (now) {
        this.search.not_item_type = now.value
      } else {
        this.search.not_item_type = ''
      }
    },

    'watch.event': function (now, old) {
      if (now) {
        this.search.event = now.value
      } else {
        this.search.event = ''
      }
    },

    'watch.not_event': function (now, old) {
      if (now) {
        this.search.not_event = now.value
      } else {
        this.search.not_event = ''
      }
    },

    'watch.whodunnit': function (now, old) {
      if (now) {
        this.search.whodunnit = now.id
      } else {
        this.search.whodunnit = ''
      }
    },

    'watch.not_whodunnit': function (now, old) {
      if (now) {
        this.search.not_whodunnit = now.id
      } else {
        this.search.not_whodunnit = ''
      }
    }
  },
  methods: {
    calcDateTime (val) {
      const datetime = new Date(val)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    linkVersion (version) {
      if (version.item_type === 'Agreement' && version.event === 'update') {
        this.$router.push({ name: 'agreementdiff', params: { id: version.item_id } })
        this.$store.dispatch('getVersionsAgreement', version.item_id)
      } else {
        return
      }
    },

    select: function (selectedOption, id) {
      console.log(selectedOption)
    },

    calcUser (user_id) {
      const num = Number(user_id)
      // console.log(num)
      if (!this.users.length) {
        return
      }
      if (num !== 0) {
        return this.users.filter(user => {
          return user.id === num
        })[0].user
      } else {
        return
      }
    },

    switchV: function (col) {
      this[col] = !this[col]
    },

    reset: function () {
      this.id = false
      this.item_type = false
      this.item_id = false
      this.event = false
      this.whodunnit = false
      this.created_at = false
    },

    all: function () {
      this.id = true
      this.item_type = true
      this.item_id = true
      this.event = true
      this.whodunnit = true
      this.created_at = true
    },

    // order By
    sort: function (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset: function (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable: function (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch: function () {
      this.search.id = ''
      this.watch.item_type = 0
      this.search.item_id = ''
      this.watch.event = 0
      this.watch.whodunnit = 0
      this.search.created_at = ''

      this.search.not_id = ''
      this.watch.not_item_type = 0
      this.search.not_item_id = ''
      this.watch.not_event = 0
      this.watch.not_whodunnit = 0
      this.search.not_created_at = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('VersionsSearch')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.item_type = obj['item_type']
      vm.search.item_id = obj['item_id']
      vm.watch.event = obj['event']
      vm.watch.whodunnit = obj['whodunnit']
      vm.search.created_at = obj['created_at']

      vm.search.not_id = obj['not_id']
      vm.watch.not_item_type = obj['not_item_type']
      vm.search.not_item_id = obj['not_item_id']
      vm.watch.not_event = obj['not_event']
      vm.watch.not_whodunnit = obj['not_whodunnit']
      vm.search.not_created_at = obj['not_created_at']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {
      id: this.search.id,
      item_type: this.watch.item_type,
      item_id: this.search.item_id,
      event: this.watch.event,
      whodunnit: this.watch.whodunnit,
      created_at: this.search.created_at,

      not_id: this.search.not_idid,
      not_item_type: this.watch.not_iditem_type,
      not_item_id: this.search.not_iditem_id,
      not_event: this.watch.not_idevent,
      not_whodunnit: this.watch.not_idwhodunnit,
      not_created_at: this.search.not_created_at
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('VersionsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  /* box-shadow: 1px 1px 1px #ccc; */
  /* border: solid 1px #ccc; */
  height: calc(100vh - 200px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f015";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>
<style lang="scss">
.VersionsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// VersionsIndex.vue?4e04d7aa